import React, { useEffect, useState } from 'react';
import {
  Box, Button, ButtonBase, Stack, TextField, Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const todayDateKey = () => new Date().toISOString().slice(0, 10);

const JourneyEvidencePeriodControl = ({
  reviewedPeriodText,
  previousIepDate,
  canEdit,
  saving,
  onSave,
}) => {
  const [editing, setEditing] = useState(false);
  const [dateValue, setDateValue] = useState(previousIepDate || '');

  useEffect(() => setDateValue(previousIepDate || ''), [previousIepDate]);

  return (
    <Box sx={{ mt: 0.75 }}>
      <Typography sx={{ fontSize: '0.78rem', lineHeight: 1.4, color: alpha(colors.semantic.ink, 0.58) }}>
        {reviewedPeriodText}
      </Typography>
      {canEdit && !editing ? (
        <ButtonBase
          onClick={() => setEditing(true)}
          sx={{ mt: 0.35, borderRadius: '10px', color: colors.brand.deep, fontSize: '0.76rem', fontWeight: 800, px: 0.35, py: 0.25 }}
        >
          {previousIepDate ? 'Change previous IEP date' : 'Add previous IEP date'}
        </ButtonBase>
      ) : null}
      {canEdit && editing ? (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.8} sx={{ mt: 0.8, alignItems: { sm: 'center' } }}>
          <TextField
            type="date"
            size="small"
            label="Previous IEP date"
            value={dateValue}
            onChange={(event) => setDateValue(event.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: todayDateKey() }}
            sx={{ maxWidth: 230 }}
          />
          <Stack direction="row" spacing={0.6}>
            <Button
              size="small"
              variant="contained"
              disabled={!dateValue || dateValue > todayDateKey() || saving}
              onClick={async () => {
                const saved = await onSave(dateValue);
                if (saved !== false) setEditing(false);
              }}
            >
              Save
            </Button>
            {previousIepDate ? (
              <Button
                size="small"
                disabled={saving}
                onClick={async () => {
                  const saved = await onSave('');
                  if (saved !== false) setEditing(false);
                }}
              >
                Remove date
              </Button>
            ) : null}
            <Button size="small" disabled={saving} onClick={() => { setDateValue(previousIepDate || ''); setEditing(false); }}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      ) : null}
    </Box>
  );
};

export default JourneyEvidencePeriodControl;
